import React from 'react';
import { useSelector } from 'react-redux';
import { useActionDispatcher } from '../../../../hooks';
import AdjustCreditsForm from './AdjustCreditsForm';
import { Modal } from '../../../../components';
import yup from '../../../../utility/yup';
import { adjustCreditRequest } from '../../../../store/modules/credits/actions';
import { User } from '../../../../types/items';
import { selectAdjustCredits } from '../../../../store/modules/credits/selectors';

type Props = {
  user: User;
  open: boolean;
  closeModalHandler: () => void;
};

const AdjustCreditsModal = ({ open, closeModalHandler, user }: Props) => {
  const { loading } = useSelector(selectAdjustCredits);
  const initialData = {
    source: 'production_fee',
    video_credits_qty: 1,
    note: '',
    user_id: user.id,
    project_id: -1,
  };

  const schema = yup.object().shape({
    source: yup.string().required().trim(),
    note: yup.string().trim(),
    video_credits_qty: yup.string().required().matches(/^-?[1-9]+([0-9]+)?$/, 'Credit Quantity must be an integer not zero').label('Credit Quantity'),
    project_id: yup.number(),
  });

  return (
    <Modal
      form={{
        data: initialData,
        validationSchema: schema,
        onSubmit: useActionDispatcher(adjustCreditRequest),
        submitTitle: 'Create Adjustment',
        loading,
      }}
      open={open}
      onCloseHandler={() => closeModalHandler()}
      title="Adjust Credits"
      hideCancel
    >
      <AdjustCreditsForm />
    </Modal>
  );
};

export default AdjustCreditsModal;
